import { HeaderComponent } from './header/header.component';

export const UI_COMPONENTS = [HeaderComponent];
